<template>
  <div class="menu">
    <v-menu
      bottom
      left
      min-width="250"
    >
      <v-btn
        slot="activator"
        icon
      >
        <v-icon>more_vert</v-icon>
      </v-btn>

      <v-list>
        <v-list-tile @click.prevent="showDialog('lock')" v-if="isActive">
          <v-list-tile-action>
            <v-icon>lock</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Zablokuj</v-list-tile-title>
          </v-list-tile-content>

        </v-list-tile>
        <v-list-tile @click.prevent="showDialog('activate')" v-if="!isActive">
          <v-list-tile-action>
            <v-icon>lock_open</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Odblokuj</v-list-tile-title>
          </v-list-tile-content>

        </v-list-tile>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'client-menu',
  props: ['status', 'clientId'],
  computed: {
    isActive() {
      return this.status === 1;
    },
  },
  methods: {
    ...mapActions('clients', [
      'setDialogVisbility',
    ]),
    showDialog(type) {
      this.setDialogVisbility({ type, id: this.clientId });
    },
    activate() {
      this.activateClient(this.clientId);
    },
  },
};
</script>

